import { Icon, StyleUtils } from '@main/core-ui';
import { Button } from '@main/pc-core-components';
import React from 'react';
import { useIntl } from 'react-intl';

import { useIsDraftPrivacyCenter } from '../../hooks';
import { draftBannerMessages } from './messages';
import { DraftPrivacyCenterBannerWrapper } from './wrappers';

/**
 * DraftPrivacyCenterBanner
 */
export const DraftPrivacyCenterBanner: React.FC = () => {
  const { isDraft, viewLive } = useIsDraftPrivacyCenter();
  const { formatMessage } = useIntl();

  return isDraft ? (
    <DraftPrivacyCenterBannerWrapper>
      <Icon type="pencil" size={30} />
      <span style={{ flexGrow: 1, fontWeight: 600 }}>
        {formatMessage(draftBannerMessages.viewingDraftDescription)}
      </span>
      <Button
        buttonType="transcend"
        onClick={viewLive}
        style={{
          padding: `${StyleUtils.Spacing.sm} ${StyleUtils.Spacing.md}`,
        }}
      >
        {formatMessage(draftBannerMessages.viewLive)}
      </Button>
    </DraftPrivacyCenterBannerWrapper>
  ) : (
    <></>
  );
};
